import { IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { List } from "../SurveyConfigurationForm/SurveyConfiguration.styled";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import PropTypes from "prop-types";

const ListOfRecurring = ({
  list,
  editRecurring,
  setOpenDeleteRecurringModal,
}) => {
  return (
    <List>
        {list.map((item, index) => {
          return (
            <Row className="my-3" key={index}>
              <Col md="8" className="d-flex align-items-center">
                {item.label}
              </Col>
              <Col md="4" className="d-flex justify-content-center">
                <Tooltip title="Edit">
                  <IconButton onClick={() => editRecurring(item)}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton onClick={() => setOpenDeleteRecurringModal(item)}>
                    <DeleteForeverIcon />
                  </IconButton>
                </Tooltip>
              </Col>
            </Row>
          );
        })}
      </List>
  );
};

export default ListOfRecurring;

ListOfRecurring.propTypes = {
  list: PropTypes.array,
  editRecurring: PropTypes.func,
  setOpenDeleteRecurringModal: PropTypes.func,
}